import { Dialog, Image, PopupHeader } from '@pcln/horizon'

import { expressDeals } from '@/constants/content'
import SearchFormProvider from '@/context/SearchFormContext'

import HorizonHotelForm from '../HorizonForm/HorizonHotelForm'
import { handleSubmitForExpressDeals } from '../SearchForm/utils'
import type { ExpressDealDialogProps } from './ExpressDealDialog.types'

const EXPRESS_DEALS_LOGO_SRC =
  'https://s1.pclncdn.com/design-assets/brand-assets/express-deals-logo-registard.svg'

export function HorizonExpressDealDialog({ isOpen, closeDialog }: ExpressDealDialogProps) {
  return (
    <Dialog.Root
      open={isOpen}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) closeDialog()
      }}
    >
      <Dialog.Portal>
        <Dialog.Backdrop />
        <Dialog.Popup size='md'>
          <div className='relative px-5 pt-5 pr-14'>
            <Image src={EXPRESS_DEALS_LOGO_SRC} isSvg height={6} className='w-[164px]' alt='Express Deals' />
            <Dialog.Close render={<PopupHeader.Close aria-label='Close Express Deals dialog' />} />
          </div>
          <Dialog.Title className='sr-only'>Hotel Express Deal Dialog</Dialog.Title>
          <Dialog.Body slots={{ content: 'flex flex-col gap-4 px-5 pt-3 pb-5' }}>
            <Dialog.Description className='text-body2 text-neutral-13'>
              {expressDeals.hotelsHeadline()}
            </Dialog.Description>
            <SearchFormProvider>
              <HorizonHotelForm onSubmit={handleSubmitForExpressDeals} pageName='landing' isExpressDeal />
            </SearchFormProvider>
          </Dialog.Body>
        </Dialog.Popup>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
